<template>
<div class="" style="padding-bottom: 90px;">
    <div class="bgp" style="text-align: center; text-shadow: 1px 1px 2px #333;">
        <div class="container">
            <h1 style="color: white; padding-top: 10px; padding-top: 170px;">{{ $t('bookH') }}</h1>
            <p style="color: white; padding-top: 10px;">{{ $t('bookP') }}</p>
        </div>
    </div>
    <div class="container" style="padding-top: 90px;">
         <div class="row" style="text-align: center;">
            <div class="col-xl col-md col-sm-12 mt-2" style="padding-top: 25px;">
                <div class="pad">
                    <img src="@/assets/PMS/invoice.png" style="width: 80px;" alt="">
                    <h5 style="font-weight: 500; padding-top: 40px;">{{ $t('cbIn') }}</h5>
                </div>
            </div>
            <div class="col-xl col-md col-sm-12 mt-2" style="padding-top: 25px;">
                <div class="pad">
                    <img src="@/assets/PMS/signature.png" style="width: 80px;" alt="">
                    <h5 style="font-weight: 500; padding-top: 40px;">{{ $t('cbDs') }}</h5>
                </div>
            </div>
            <div class="col-xl col-md col-sm-12 mt-2" style="padding-top: 25px;">
                <div class="pad">
                    <img src="@/assets/PMS/id.png" style="width: 80px;" alt="">
                    <h5 style="font-weight: 500; padding-top: 40px;">{{ $t('cbId') }}</h5>
                </div>
            </div>
            <div class="col-xl col-md col-sm-12 mt-2" style="padding-top: 25px;">
                <div class="pad">
                    <img src="@/assets/PMS/gear.png" style="width: 80px;" alt="">
                    <h5 style="font-weight: 500; padding-top: 40px;">{{ $t('cbWid') }}</h5>
                </div>
            </div>
        </div>
    </div>
    <div class="container" style="padding-top: 100px;">
        <div class="row" style="margin-top: 90px; margin-bottom: 90px;">
            <div class="col-xl-6 col-md-6 col-sm-12 mt-3 pl-2">
                <h4 class="pl-3" style="">{{ $t('bookH1') }}</h4>
                <ul style="color: #888888;">
                    <li>{{ $t('bookP1') }}</li>
                    <li>{{ $t('bookP2') }}</li>
                    <li>{{ $t('bookP3') }}</li>
                    <li>{{ $t('bookP4') }}</li>
                </ul>

            </div>
            <div class="col-xl-6 col-md-6 col-sm-12 mt-3">
                <img @click="source = require('@/assets/BOOK/book1.png')" v-b-modal.modal-1 src="@/assets/BOOK/book1.png" class="col" alt="">
            </div> 
        </div>

        <div class="row" style="margin-top: 90px; margin-bottom: 90px;">
            <div class="col-xl-6 col-md-6 col-sm-12 mt-3">
                <img @click="source = require('@/assets/BOOK/book2.png')" v-b-modal.modal-1 src="@/assets/BOOK/book2.png" class="col" alt="">
            </div>
            <div class="col-xl-6 col-md-6 col-sm-12 mt-3 pl-2">
                <h4 class="pl-3" style="">{{ $t('bookH2') }}</h4>
                <ul style="color: #888888;">
                    <li>{{ $t('bookP5') }}</li>
                    <li>{{ $t('bookP6') }}</li>
                    <li>{{ $t('bookP7') }}</li>
                </ul>
            </div>
        </div>

        <div class="row" style="margin-top: 90px; margin-bottom: 90px;">
            <div class="col-xl-6 col-md-6 col-sm-12 mt-3 pl-2">
                <h4 class="pl-3" style="">{{ $t('bookH3') }}</h4>
                <ul style="color: #888888;">
                    <li>{{ $t('bookP8') }}</li>
                    <li>{{ $t('bookP9') }}</li>
                    <li>{{ $t('bookP10') }}</li>
                    <li>{{ $t('bookP11') }}</li>
                </ul>

            </div>
            <div class="col-xl-6 col-md-6 col-sm-12 mt-3">
                <img @click="source = require('@/assets/BOOK/book3.png')" v-b-modal.modal-1 src="@/assets/BOOK/book3.png" class="col" alt="">
            </div>
        </div>

        <div class="row" style="margin-top: 90px; margin-bottom: 90px;">
            <div class="col-xl-6 col-md-6 col-sm-12 mt-3">
                <img @click="source = require('@/assets/BOOK/book4.png')" v-b-modal.modal-1 src="@/assets/BOOK/book4.png" class="col" alt="">
            </div>
            <div class="col-xl-6 col-md-6 col-sm-12 mt-3 pl-2">
                <h4 class="pl-3" style="">{{ $t('bookH4') }}</h4>
                <ul style="color: #888888;">
                    <li>{{ $t('bookP12') }}</li>
                    <li>{{ $t('bookP13') }}</li>
                    <li>{{ $t('bookP14') }}</li>
                    <li>{{ $t('bookP15') }}</li>
                    <li>{{ $t('bookP16') }}</li>
                </ul>
            </div>
        </div>

        <div class="row" style="margin-top: 90px; margin-bottom: 90px;">
            <div class="col-xl-6 col-md-6 col-sm-12 mt-3 pl-2">
                <h4 class="pl-3" style="">{{ $t('bookH5') }}</h4>
                <ul style="color: #888888;">
                    <li>{{ $t('bookP17') }}</li>
                    <li>{{ $t('bookP18') }}</li>
                    
                </ul>
            </div>
            <div class="col-xl-6 col-md-6 col-sm-12 mt-3">
                <img @click="source = require('@/assets/BOOK/book5.jpg')" v-b-modal.modal-1 src="@/assets/BOOK/book5.jpg" class="col" alt="">
            </div>
        </div>

        <div class="row" style="margin-top: 90px; margin-bottom: 90px;">
            <div class="col-xl-6 col-md-6 col-sm-12 mt-3">
                <img @click="source = require('@/assets/BOOK/book6.jpg')" v-b-modal.modal-1 src="@/assets/BOOK/book6.jpg" class="col" alt="">
            </div>
            <div class="col-xl-6 col-md-6 col-sm-12 mt-3 pl-2">
                <h4 class="pl-3" style="">{{ $t('bookH6') }}</h4>
                <ul style="color: #888888;">
                    <li>{{ $t('bookP19') }}</li>
                                    </ul>
            </div>
        </div>

        <div class="row" style="margin-top: 90px; margin-bottom: 90px;">
            <div class="col-xl-6 col-md-6 col-sm-12 mt-3 pl-2">
                <h4 class="pl-3" style="">{{ $t('bookH7') }}</h4>
                <ul style="color: #888888;">
                    <li>{{ $t('bookP20') }}</li>
                    <li>{{ $t('bookP21') }}</li>
                    <li>{{ $t('bookP22') }}</li>
                    <li>{{ $t('bookP23') }}</li>
                    <li>{{ $t('bookP24') }}</li>
                    <li>{{ $t('bookP25') }}</li>
                    <li>{{ $t('bookP26') }}</li>
                </ul>
            </div>
            <div class="col-xl-6 col-md-6 col-sm-12 mt-3">
                <img @click="source = require('@/assets/BOOK/book7.jpg')" v-b-modal.modal-1 src="@/assets/BOOK/book7.jpg" class="col" alt="">
            </div>
        </div>
        <div>
            <b-modal id="modal-1" size="xl" style="" hide-footer hide-header>
                <img :src="source" class="col" alt="">
            </b-modal>
        </div>
    
    </div>
</div> 
</template>

<script>

export default {
  name: 'BookEngine',
  metaInfo: {
    title: 'Booking Engine',
  },
  data(){
    return{
       source: require('@/assets/PMS/res9.jpg'),
    }
  },
  async mounted(){
  },

  methods : {
      
  },

  components: {

  },
  props: {

  },
      
 computed: {
  },
}

</script>

<style scoped>
.bgp{
background-image: url("../../assets/att.jpg");
background-size: cover;
height: 400px;
}
.center {
margin-left: 45%;
padding-top: 200px;
color: white;
}
.underline {
  color: black;
  display: inline-block;
  font-size: 0.875rem;
  padding-bottom:2px;
  background-image: linear-gradient(red, red);
  background-position: 0 100%; /*OR bottom left*/
  background-size: 0% 2px;
  background-repeat: no-repeat;
  transition:
  background-size 0.3s,
  background-position 0s 0.3s; /*change after the size immediately*/
}
.underline:hover {
 background-position: 100% 100%; /*OR bottom right*/
  background-size: 100% 2px;
}

.pad{
    background: #f7f9fc;; 
    padding: 40px; 
    border-radius: 5px; 
    height: 255px;
}

.pad:hover{
    margin-top: -5px !important;
    transition: 350ms;
    box-shadow: 0px 10px 20px 2px #bbb8b8;
}


</style>
